import { useUtilisateurService } from '@europrocurement/l2d-domain';
import {
    JointureUtilisateurGroupeTravailJsonldUserworkgroupRead,
    UtilisateursJsonldUserworkgroupRead,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';

export type UtilisateursGroupesTravail = UtilisateursJsonldUserworkgroupRead &
    Record<string, unknown>;

export type searchUtilisateursGroupesTravailProps = {
    groupetravail2?: string[];
    historicInscription: false;
};
const useUtilisateursGroupesTravail = () => {
    const { utilisateursGroupeTravailApi } = useUtilisateurService();
    let searchCollectionTimeout: number | undefined;

    const searchUtilisateursGroupesTravail = ({
        groupetravail2,
        historicInscription = false,
    }: searchUtilisateursGroupesTravailProps): Promise<
        Array<JointureUtilisateurGroupeTravailJsonldUserworkgroupRead>
    > =>
        new Promise((resolve, reject) => {
            clearTimeout(searchCollectionTimeout);

            const requestParameters = {
                groupetravail2,
                historicInscription,
            };

            searchCollectionTimeout = setTimeout(() => {
                utilisateursGroupeTravailApi
                    .apiUtilisateurgroupetravailGetCollection(requestParameters)
                    .then((res) =>
                        // Extract users from groups users
                        resolve(res.data['hydra:member']),
                    )
                    .catch(() => reject());
            }, 300);
        });

    return { searchUtilisateursGroupesTravail };
};

export default useUtilisateursGroupesTravail;
